// seller-service endpoint paths (relative to VITE_SELLER_API_URL). The service
// mounts under the `/api` global prefix. Referenced via this constant so a path
// change is a single edit — never hard-coded at call sites. Per-resource paths
// are builder functions so the id is interpolated in one place.
export const listingRequestEndpointPaths = {
  LISTING_REQUESTS: '/api/listing-requests',
  // Title Deed step: reads the uploads so the Verify Details step can be pre-filled.
  LISTING_REQUEST_DOCUMENT_EXTRACTIONS: '/api/listing-requests/document-extractions',
  LISTING_REQUEST_STATUS_COUNTS: '/api/listing-requests/status-counts',
  LISTING_REQUEST_PAYOUT_SUMMARY: '/api/listing-requests/payout-summary',
  LISTING_REQUEST_DRAFTS: '/api/listing-requests/drafts',
  // Onboarding fee quote. Lives under /fees rather than /listing-requests
  // because it prices a number the seller is still considering — there is no
  // request yet to hang it off.
  ONBOARDING_FEE_QUOTE: '/api/fees/onboarding-quote',
  listingRequest: (id: string) => `/api/listing-requests/${id}`,
  listingRequestTimeline: (id: string) => `/api/listing-requests/${id}/timeline`,
  listingRequestAgreements: (id: string) => `/api/listing-requests/${id}/agreements`,
  // Phase B seller actions.
  listingRequestPriceResponse: (id: string) => `/api/listing-requests/${id}/price-response`,
  listingRequestWithdraw: (id: string) => `/api/listing-requests/${id}/withdraw`,
  // Drafts: save over an existing draft, then submit it. A draft is discarded with
  // DELETE on `listingRequest(id)`.
  listingRequestDraft: (id: string) => `/api/listing-requests/${id}/draft`,
  listingRequestSubmit: (id: string) => `/api/listing-requests/${id}/submit`,
  // UAE Pass agreement signing (per agreement + signatory).
  agreementSignInitiate: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/sign`,
  agreementShareLink: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/share-link`,
  agreementSignComplete: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/sign/complete`,
  agreementSignDecline: (id: string, agreementId: string, signatoryId: string) =>
    `/api/listing-requests/${id}/agreements/${agreementId}/signatories/${signatoryId}/decline`,
} as const
